export default __webpack_public_path__ + "static/media/sort.72ee1019.svg";